<template>
    <section class="call-to-action">
        <h2
            class="cta-title h3"
            v-test:title
        >
            {{ title }}
        </h2>
        <div
            v-if="description"
            v-html="description"
            class="cta-description"
            v-test:description
        />
        <lazy-image
            v-if="image && image.src"
            class="cta-image"
            :src="image.src"
            :alt="image.alt"
            :width="image.width"
            :height="image.height"
            v-test:image
        />
        <div class="buttons">
            <div
                class="button-container"
                v-for="button in buttons"
                :key="button.name"
            >
                <b-button
                    :to="button.to"
                    :href="button.href"
                    variant="primary"
                    class="button"
                    v-test:button
                >
                    {{ button.name }}
                </b-button>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'call-to-action',

        props: {
            title: {
                type: String,
                default: '',
            },

            description: {
                type: String,
                default: '',
            },

            image: {
                type: Object,
                default: () => ({}),
            },

            buttons: {
                type: Array,
                default: () => ([]),
            },
        },
    };
</script>

<style lang="scss" scoped>
    .call-to-action {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    .cta-title {
        font-weight: bold;
        letter-spacing: $letter-spacing;
        text-align: center;
    }

    .cta-image {
        max-width: 270px;
        max-height: 225px;
        width: auto;
        height: auto;
    }

    .cta-description {
        text-align: center;
        padding: 0 25px 20px;

        @include media-breakpoint-up(sm) {
            padding: 0 45px 20px;
        }

        @include media-breakpoint-up(lg) {
            font-size: rem(24px);
            letter-spacing: $letter-spacing;
            line-height: rem(32px);
            padding: 0 0 15px;
        }
    }

    .buttons {
        display: flex;
        margin: 30px -10px 0;
        justify-content: center;
    }

    .button-container {
        padding: 0 10px;
        min-width: 166px;
        @include media-breakpoint-up(lg) {
            min-width: 218px;
        }
    }

    .button {
        min-width: 100%;
    }
</style>
